import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { RootState } from "../store";
import { useState } from "react";
import { Spinner } from "@phosphor-icons/react";

export const AuthLayout = () => {
  const isSSO = import.meta.env.VITE_SSO === "true";
  const { token, usuario } = useSelector((state: RootState) => state.ui);

  const [isLoading, setIsLoading] = useState(!isSSO && !usuario?.id);

  if (!token) {
    return <Navigate to="/auth/login" replace />;
  }

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Spinner size={32} />
      </div>
    );
  }
  return <Outlet />;
};
